import { useState, useEffect } from 'react';
import styles from '../views/Calibration/TagWalkPage.module.scss';

export const CalibrationStatus = ({ data }) => {
  const [calibrationStatus, setCalibrationStatus] = useState({});
  const [calibrationDate, setCalibrationDate] = useState({});

  const formatDate = function (date) {
    let index = date.indexOf('T');
    return date.substring(0, index);
  };

  useEffect(() => {
    if (data['last_calibration_date']) {
      let newDate = formatDate(data['last_calibration_date']);
      setCalibrationDate({
        date: newDate,
      });
    } else {
      setCalibrationDate({
        date: 'Never',
      });
    }
    if (data['last_calibration_status']) {
      setCalibrationStatus({
        status: data['last_calibration_status'],
      });
    } else {
      setCalibrationStatus({
        status: 'Never',
      });
    }
  }, [data]);

  return (
    <div>
      <p className={styles.row}>
        <span className={styles.label}> Last Calibration Status:</span>
        <strong className={styles.value}>{calibrationStatus.status}</strong>
      </p>
      <p className={styles.row}>
        <span className={styles.label}>Last Calibration Date: </span>
        <strong className={styles.value}> {calibrationDate.date}</strong>
      </p>
    </div>
  );
};
